import React from 'react';

export default {
  svg: (
    <g>
      <path
        d="M12 5.17c.414 0 .75.386.75.862v10.342c0 .475-.336.861-.75.861H.75c-.414 0-.75-.386-.75-.861V6.032c0-.476.336-.861.75-.861H12zm6 1.724v9.48l-4.5-1.976V8.87L18 6.894zm-6.75 0H1.5v8.618h9.75V6.894zm5.25 2.503l-1.5.658v3.157l1.5.658V9.397zM8.25 0c1.243 0 2.25 1.157 2.25 2.585 0 1.377-.937 2.503-2.118 2.581l-.132.005c-.731 0-1.38-.401-1.792-1.022l-.084-.136c-.374.651-1 1.095-1.719 1.152L4.5 5.17c-1.243 0-2.25-1.158-2.25-2.586 0-1.377.937-2.502 2.118-2.58L4.5 0c.783 0 1.473.46 1.876 1.158.374-.652 1-1.096 1.719-1.152L8.25 0zm0 1.724a.706.706 0 00-.567.298l-.055.085-.277.48.273.473c.122.21.314.35.531.38l.095.007c.414 0 .75-.386.75-.862s-.336-.861-.75-.861zm-3.75 0c-.414 0-.75.385-.75.861s.336.862.75.862a.706.706 0 00.567-.299l.055-.085.276-.481-.272-.471a.743.743 0 00-.531-.38L4.5 1.723z"
        fill="#878787"
        fillRule="evenodd"
      />
    </g>
  )
};
